module.exports = __webpack_public_path__ + "img/smartphone.5a53f3af.svg";